import { createLazyFileRoute } from "@tanstack/react-router"

import HomePage from "#/pages/HomePage"
import { routes } from "#/shared/constants"

export const Route = createLazyFileRoute(routes.HOME)({
  component: () => <HomePage />,
})
